<template>
    <div>
        <comentariosList />
        <comentariosForm :id="id" />
    </div>
</template>

<script>
    import comentariosForm from './comentariosForm';
    import comentariosList from './comentariosList';
    export default {
        props: {
            id: String
        },
        components: {
            comentariosForm,
            comentariosList
        },
    }
</script>

<style lang="scss" scoped>

</style>